import script from "./Caption.vue?vue&type=script&lang=tsx"
export * from "./Caption.vue?vue&type=script&lang=tsx"

import "./Caption.vue?vue&type=style&index=0&id=280c27d0&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280c27d0"]])

export default __exports__